/**
 * The CurrencySettings static object represents settings for the currency data type.
 * It provides digits for a specific currency and the default scale.
 */
var CurrencySettings = {};

/**
 * Update the default currency setting with customization.
 *
 * @param {Object} oConfig - A configuration object that is used to specify the currency settings.
 * @param {string} oConfig.defaultScale - A custom settings object that will be used for defining the default scale.
 * @param {string} oConfig.customCurrencies - A custom settings object that will be used for defining currency digits.
 * @public
 * @static
 */
CurrencySettings.update = function(oConfig) {
	var sCurrency;

	if (oConfig) {
		// Update default scale
		if (typeof oConfig.defaultScale === 'number') {
			CurrencySettings.DEFAULT_SCALE = oConfig.defaultScale;
		}
		// Update custom currencies
		if (oConfig.customCurrencies) {
			for (sCurrency in oConfig.customCurrencies) {
				CurrencySettings.DIGITS[sCurrency] = oConfig.customCurrencies[sCurrency].digits;
			}
		}
	}
};

/**
 * Defines the display default scale that is used for alignment. This has no effect on the technical scale of currency
 * values. It is only used for alignment purposes so that different currencies with different scale are still aligned
 * correctly.
 *
 * @type {number}
 */
CurrencySettings.DEFAULT_SCALE = 3;

CurrencySettings.DIGITS = {
	'ADP': 0,
	'AFN': 0,
	'ALL': 0,
	'BHD': 3,
	'BIF': 0,
	'BYR': 0,
	'CLF': 4,
	'CLP': 0,
	'DEFAULT': 2,
	'DJF': 0,
	'ESP': 0,
	'GNF': 0,
	'HUF': 0,
	'IQD': 0,
	'IRR': 0,
	'ISK': 0,
	'ITL': 0,
	'JOD': 3,
	'JPY': 0,
	'KMF': 0,
	'KPW': 0,
	'KRW': 0,
	'KWD': 3,
	'LAK': 0,
	'LBP': 0,
	'LUF': 0,
	'LYD': 3,
	'MGA': 0,
	'MGF': 0,
	'MMK': 0,
	'MRO': 0,
	'OMR': 3,
	'PYG': 0,
	'RSD': 0,
	'RWF': 0,
	'SLL': 0,
	'SOS': 0,
	'STD': 0,
	'SYP': 0,
	'TMM': 0,
	'TND': 3,
	'TRL': 0,
	'TWD': 0,
	'UGX': 0,
	'UYI': 0,
	'UYW': 4,
	'VND': 0,
	'VUV': 0,
	'XAF': 0,
	'XOF': 0,
	'XPF': 0,
	'YER': 0,
	'ZMK': 0,
	'ZWD': 0
};

module.exports = CurrencySettings;



//////////////////
// WEBPACK FOOTER
// ./core/xlsx/src/binding/type/CurrencySettings.js
// module id = 12
// module chunks = 0